var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-attach-file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0628 4.74935V13.8535C13.0628 15.6031 11.6457 17.0202 9.89616 17.0202C8.14658 17.0202 6.72949 15.6031 6.72949 13.8535V3.95768C6.72949 3.43278 6.93801 2.92937 7.30918 2.5582C7.68034 2.18703 8.18375 1.97852 8.70866 1.97852C9.23357 1.97852 9.73698 2.18703 10.1081 2.5582C10.4793 2.92937 10.6878 3.43278 10.6878 3.95768V12.2702C10.6878 12.7056 10.3316 13.0619 9.89616 13.0619C9.46074 13.0619 9.10449 12.7056 9.10449 12.2702V4.74935H7.91699V12.2702C7.91699 12.7951 8.12551 13.2985 8.49668 13.6697C8.86784 14.0408 9.37125 14.2494 9.89616 14.2494C10.4211 14.2494 10.9245 14.0408 11.2956 13.6697C11.6668 13.2985 11.8753 12.7951 11.8753 12.2702V3.95768C11.8753 2.2081 10.4582 0.791016 8.70866 0.791016C6.95908 0.791016 5.54199 2.2081 5.54199 3.95768V13.8535C5.54199 16.2602 7.48949 18.2077 9.89616 18.2077C12.3028 18.2077 14.2503 16.2602 14.2503 13.8535V4.74935H13.0628Z",
    fill: "#2898A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attach-file.fe0d43bd03732161842d0a6c0327da4c.svg";
export { ForwardRef as ReactComponent };